import PostApi from '@/postApi';
export default {
	namespaced: true,
	state: {
		
	},
	actions: {
		async getCaptcha({commit},param) {
			console.log('getCaptcha',commit);
			const getCaptchaData = await PostApi.getCaptcha(param);
			return getCaptchaData;
		},
		async postRegister({commit},param) {
			console.log('postRegister',commit);
			const getRegisterData = await PostApi.postRegister(param);
			return getRegisterData;
		},
		async postChangePwd({commit},param) {
			console.log('postChangePwd',commit);
			const getChangePwdData = await PostApi.postChangePwd(param);
			return getChangePwdData;
		},
	},
	mutations: {
	}
}
